/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CreateHistoricalInformationFormData } from '../../models/create-historical-information-form-data';

export interface CreateRoadHistoricalInformationRecord$Params {
  roadId: number;
  body: CreateHistoricalInformationFormData;
}

export function createRoadHistoricalInformationRecord(
  http: HttpClient,
  rootUrl: string,
  params: CreateRoadHistoricalInformationRecord$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(
    rootUrl,
    createRoadHistoricalInformationRecord.PATH,
    'post',
  );
  if (params) {
    rb.path('roadId', params.roadId, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({
          body: undefined,
        }) as StrictHttpResponse<void>;
      }),
    );
}

createRoadHistoricalInformationRecord.PATH =
  '/me/roads/{roadId}/historicalInformation/submissions';
